"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubConnaissancesMarcheFinancierProduitsEpargneTrads = void 0;
exports.ESubConnaissancesMarcheFinancierProduitsEpargneTrads = {
    aucune: "Aucune",
    faible: "Faible",
    moyenne: "Moyenne",
    eleve: "Elevé",
    expert: "Expert",
};
